/**
 * Редакции анонса ежедневной «Битвы с AI Claude Opus» в главном меню
 * (AiMatchNewsModal). Анонс показывается один раз на редакцию: когда в событии
 * меняется то, о чем анонс уже рассказал (время начала), номер редакции
 * растет — и анонс снова видят все, включая закрывших прежний. Правка базы
 * для этого не нужна: «закрыт» — значит закрыта текущая редакция.
 *
 * Модуль общий для сервера (признаки профиля и отметка закрытия) и клиента
 * (какую редакцию он показал).
 */

// 1 — первый анонс события (начало в 20:00 по Москве);
// 2 — начало перенесено на 21:00
export const AI_MATCH_NEWS_VERSION = 2;

/**
 * Какую редакцию анонса игрок закрыл: 0 — никакую. Аккаунты, закрывшие анонс
 * до появления номера редакции, хранят только дату закрытия — это редакция 1.
 *
 * @param {{aiMatchNewsSeenAt?: Date|string|null, aiMatchNewsSeenVersion?: number|null}|null} user
 * @returns {number}
 */
export const getAiMatchNewsSeenVersion = (user) => {
  const version = Number(user?.aiMatchNewsSeenVersion);
  if (Number.isInteger(version) && version >= 1) {
    return version;
  }
  return user?.aiMatchNewsSeenAt ? 1 : 0;
};

// Текущая редакция закрыта — анонс игроку больше не показывается
export const checkIfAiMatchNewsSeen = (user) => getAiMatchNewsSeenVersion(user) >= AI_MATCH_NEWS_VERSION;

/**
 * Игрок закрыл прежнюю редакцию, а текущую еще нет: анонс для него —
 * известие о переменах («новое время»), а не первое знакомство с событием.
 */
export const checkIfAiMatchNewsUpdate = (user) => {
  const seenVersion = getAiMatchNewsSeenVersion(user);
  return seenVersion >= 1 && seenVersion < AI_MATCH_NEWS_VERSION;
};

/**
 * Редакция, которую закрывает запрос отметки. Клиент присылает ту, что
 * показал. Старый клиент из кэша (сборка до редакций, PWA) не шлет ничего: он
 * показал первую редакцию со своим прежним временем, и текущую она не
 * закрывает — после обновления сборки игрок увидит анонс с новым временем.
 * Редакции новее серверной не бывает — режем до текущей.
 *
 * @param {*} rawVersion - поле version из тела запроса
 * @returns {number}
 */
export const resolveAiMatchNewsClosedVersion = (rawVersion) => {
  const version = Number(rawVersion);
  if (!Number.isInteger(version) || version < 1) {
    return 1;
  }
  return Math.min(version, AI_MATCH_NEWS_VERSION);
};
